import type { ReactNode } from "react";

type PublicPageHeroProps = {
  eyebrow: string;
  title: string;
  lede?: ReactNode;
  updated?: string;
  marks?: ReactNode;
};

export function PublicPageHero({ eyebrow, title, lede, updated, marks }: PublicPageHeroProps) {
  return (
    <header className="public-page-hero">
      {marks ? <div className="public-page-hero-marks">{marks}</div> : null}
      <p className="public-eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      {lede ? <p className="public-lede">{lede}</p> : null}
      {updated ? (
        <p className="public-meta">
          <span className="public-chip">Last updated {updated}</span>
        </p>
      ) : null}
    </header>
  );
}
